import { Button, CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Item } from "lib/features/item/types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: { xs: "80%", sm: "40%" },
  maxHeight: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "680px" },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  margin: "0px 0px",
  p: { xs: 2, md: 5 },
};

interface DeleteBasicItemModalProps {
  open: boolean;
  close: () => void;
  customStyle?: object;
  sx?: object;
  loading: boolean;
  onSubmit: any;
  item: Item | null;
}

export default function DeleteBasicItemModal({
  open,
  close,
  customStyle = {},
  sx = {},
  loading,
  onSubmit,
  item,
}: DeleteBasicItemModalProps) {
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
      sx={{ ...sx }}
    >
      <Box sx={{ ...style, ...customStyle }}>
        {/* Modal Title */}
        <Typography sx={{ fontSize: "22px", fontWeight: "600" }}>
          {item?.hide_item ? "Show Availabilities" : "Hide Availabilities"}
        </Typography>

        {/* Modal Body */}
        <Box mt={2}>
          <Typography sx={{ fontSize: "17px", fontWeight: "400" }}>
            {item?.hide_item
              ? "This will show your FareHarbor item availabilities on the Referee Landing Page"
              : "This will hide your FareHarbor item availabilities from the Referee Landing Page"}
          </Typography>
        </Box>

        {/* Modal Footer */}
        <Box mt={2} display="flex" justifyContent="flex-end" gap={"10px"}>
          <Button
            sx={{
              width: "150px",
              backgroundColor: "#2E7D32",
              fontWeight: 600,
              color: "#FFF",
              "&:hover": {
                backgroundColor: "#2E7D32",
              },
            }}
            onClick={onSubmit}
          >
            {loading ? (
              <CircularProgress sx={{ color: "white" }} size={20} />
            ) : (
              "Confirm"
            )}
          </Button>

          <Button
            variant="outlined"
            sx={{
              width: "150px",
              borderColor: "#000",
              color: "#000",
              fontWeight: 600,
              "&:hover": {
                borderColor: "#000",
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={close}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
